import React from 'react'

import Spinner from 'app/sm/common/spinner'

export const LoadingScreen = () => (
  <div>
    <Spinner />
  </div>
)
